import imagesloaded from 'imagesloaded';

import makeModal from '@/views/modal/make_modal';
import { initPhotos, buildStorageMap } from '../storages-v4/show';

import track from '@/helpers/track';
import { isMobile } from '@/helpers/mobile_detect';

import PopperTooltipV4 from '@/views/popper_tooltip_v4';

let authModal = null;
let guestVisitModal = null;

$(document).on('turbolinks:before-cache', () => {
  if (authModal) {
    authModal.destroy();
    authModal = null;
  }
  if (guestVisitModal) {
    guestVisitModal.destroy();
    guestVisitModal = null;
  }
});

pageLoad('boxes_show', () => {
  if (!document.querySelector('.boxes-v4-show')) { return; }

  const $storagePhoto = $(
    isMobile() ?
      '.slide_1 .photos a.photo' :
      '.slide_1 .photos a.photo:not(.size)'
  );
  if ($storagePhoto.length) {
    imagesloaded($storagePhoto.toArray(), () => initPhotos($storagePhoto));
  }

  if (!isMobile()) {
    $('.slide_1 .photos a.photo.size').on('click', e => {
      e.preventDefault();
    });
  }

  buildStorageMap();
  track({ event: 'view_box' });

  $(`
    article.v4.slide_1 .cell-3,
    article.v4.slide_1 .cell-4
  `)
    .find('.b-tooltip_trigger-v4')
    .each((_index, node) => new PopperTooltipV4(node));

  $('article.v4.slide_1 .cell-6 .guest-visit-trigger').one('click', async ({ currentTarget }) => {
    const $trigger = $(currentTarget);

    guestVisitModal ||= makeModal({
      trigger: $trigger[0],
      // the same switch the component makes: a client whose phone the server knows gets the
      // short informational variant, a visitor wo an account gets the contact form
      silhouette: $trigger.data('profile_phone_number') ?
        'guest_visit_signed_in' :
        'guest_visit_signed_out',
      importComponent: async () => await import('@/vue/modals/guest_visit'),
      props: {
        storageId: $trigger.data('storage_id'),
        boxId: $trigger.data('box_id'),
        isBluetoothLocks: $trigger.data('is_bluetooth_locks'),
        profilePhoneNumber: $trigger.data('profile_phone_number'),
        profileName: $trigger.data('profile_name'),
        graphqlUrl: $trigger.data('graphql_url'),
        confirmationUrl: $trigger.data('confirmation_url'),
        confirmationType: $trigger.data('confirmation_type'),
        privacyUrl: $trigger.data('privacy_url'),
        privacyConsentUrl: $trigger.data('privacy_consent_url'),
        resendCodeInterval: $trigger.data('resend_code_interval'),
        mobileAppUrl: $trigger.data('mobile_app_url'),
        mobileAppSvg: $trigger.data('mobile_app_svg')
      },
      onShow: () => {
        track({ event: 'guest_visit_form_opened', form_location: 'box_page' });
      }
    })
      .show();
  });

  $(`
    article.v4.slide_1 .cell-1 .rent:not(a),
    .mobile-sticky-area .rent:not(a)
  `).one('click', async ({ currentTarget }) => {
    const $trigger = $(currentTarget);

    authModal ||= makeModal({
      trigger: $trigger[0],
      silhouette: 'auth_sign_up',
      importComponent: async () => await import('@/vue/modals/auth/index'),
      props: {
        graphqlUrl: $trigger.data('graphql_url'),
        confirmationUrl: $trigger.data('confirmation_url'),
        confirmationType: $trigger.data('confirmation_type'),
        resendCodeInterval: $trigger.data('resend_code_interval'),
        nextUrl: $trigger.data('next_url'),
        privacyUrl: $trigger.data('privacy_url'),
        privacyConsentUrl: $trigger.data('privacy_consent_url'),
        signUpMethod: 'box_rent_form'
      },
      onShow: () => {
        track($trigger.data('track-event-data'));
      }
    })
      .show();
  });

  const $lead = $('#lead_app');
  if ($lead.length) {
    buildLeadApp($lead);
  }
});

export async function buildLeadApp($node) {
  const { createApp } = await import(/* webpackChunkName: "vue" */ 'vue');
  const { default: App } = await import('@/vue/storage_schema_boxes/lead_form');

  const app = createApp(App, {
    i18nKey: 'rented_box',
    submitUrl: $node.data('lead_submit_url'),
    leadType: $node.data('lead_type'),
    graphqlUrl: $node.data('graphql_url'),
    privacyUrl: $node.data('privacy_url'),
    privacyConsentUrl: $node.data('privacy_consent_url')
  });
  app.mount($node[0]);
}
